import { useState } from 'react'
import './banners.css'
import { Link, useNavigate } from 'react-router-dom'
import { useGetAllBannersQuery, useDeleteBannerMutation } from '../../services/bannerApi'
import { Add, ViewCarouselOutlined, ImageOutlined } from "@mui/icons-material";
import {
  AdminPageHeader,
  AdminToolbar,
  AdminTable,
  AdminBadge,
  AdminButton,
  AdminRowActions,
  useConfirm,
  useToast,
} from '../../components/ui'

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000/'

function Banners() {
  const { data, isLoading } = useGetAllBannersQuery()
  const [deleteBanner] = useDeleteBannerMutation()
  const navigate = useNavigate();
  const confirm = useConfirm();
  const toast = useToast();
  const [search, setSearch] = useState("");

  const allRows = data ?? []
  const term = search.trim().toLowerCase();
  const rows = term ? allRows.filter((b) => b.title.toLowerCase().includes(term)) : allRows;

  const handleEdit = (props) => {
    navigate(`/admin/banner/edit/${props}`);
  };

  const handleDelete = async (banner) => {
    const ok = await confirm({
      title: "Delete banner",
      message: `Delete "${banner.title}"? This can't be undone.`,
      confirmLabel: "Delete",
      danger: true,
    });
    if (!ok) return;
    const res = await deleteBanner(banner.id)
    if (res.error) toast.error('Could not delete this banner.')
    else toast.success("Banner deleted.")
  }

  const columns = [
    {
      key: "image",
      header: "Image",
      render: (b) => (
        <div className="bannerThumb">
          {b.image ? <img src={`${API_BASE}${b.image}`} alt="" /> : <ImageOutlined className="bannerThumb__fallback" />}
        </div>
      ),
    },
    { key: "title", header: "Title" },
    { key: "sort_order", header: "Order", align: "right" },
    { key: "is_active", header: "Status", render: (b) => <AdminBadge variant={b.is_active ? "success" : "neutral"}>{b.is_active ? "Active" : "Inactive"}</AdminBadge> },
    { key: "is_currently_active", header: "Live Now", render: (b) => <AdminBadge variant={b.is_currently_active ? "info" : "neutral"}>{b.is_currently_active ? "Yes" : "No"}</AdminBadge> },
    {
      key: "actions",
      header: "",
      align: "right",
      render: (b) => <AdminRowActions label={b.title} onEdit={() => handleEdit(b.id)} onDelete={() => handleDelete(b)} />,
    },
  ];

  return (
    <div>
      <AdminPageHeader
        title="Banners"
        subtitle="Manage homepage promotional banners."
        breadcrumbs={[{ label: "Dashboard", to: "/admin/dashboard" }, { label: "Banners" }]}
        primaryAction={
          <Link to="/admin/banner/new">
            <AdminButton icon={<Add />}>New Banner</AdminButton>
          </Link>
        }
      />
      <AdminToolbar searchValue={search} onSearchChange={setSearch} searchPlaceholder="Search banners by title..." />
      <AdminTable
        columns={columns}
        rows={rows}
        rowKey={(b) => b.id}
        isLoading={isLoading}
        emptyIcon={<ViewCarouselOutlined />}
        emptyTitle={search ? "No banners match your search" : "No banners yet"}
        pageSize={10}
      />
    </div>
  );
}

export default Banners
